/* Canonical schema.org Organization payload for ZHELTA LLC.
 *
 * Used by:
 *   - /copyright (legal page) via SeoHead's jsonLd prop
 *   - /        (homepage)     via StructuredData component
 *
 * Keeping a single source of truth here means a change to address, email,
 * or sameAs links propagates everywhere automatically — Google rewards
 * consistent identity signals across a domain. */

export function getOrganizationSchema(origin) {
  const safeOrigin = origin || (typeof window !== 'undefined' ? window.location.origin : 'https://zhelta.com');
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': `${safeOrigin}/#organization`,
    name: 'ZHELTA LLC',
    legalName: 'ZHELTA LLC',
    alternateName: ['ZHELTA', 'Zhelta'],
    url: safeOrigin,
    logo: `${safeOrigin}/logo512.png`,
    image: `${safeOrigin}/og-images/home.svg`,
    email: 'support@zhelta.com',
    slogan: 'Your last stop for tech services',
    foundingDate: '2012',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '167 Madison Avenue, Suite 205 #1076',
      addressLocality: 'New York',
      addressRegion: 'NY',
      postalCode: '10016',
      addressCountry: 'US',
    },
    contactPoint: [
      {
        '@type': 'ContactPoint',
        contactType: 'customer support',
        email: 'support@zhelta.com',
        availableLanguage: ['English', 'Spanish'],
      },
    ],
    sameAs: [
      'https://www.linkedin.com/company/zhelta-llc/',
      'https://www.facebook.com/profile.php?id=61562259287313',
      'https://www.instagram.com/zhelta_support',
      'https://www.youtube.com/@zheltallc',
      safeOrigin,
    ],
  };
}
